import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../Auth/auth-service.service';
import { ServiceService } from '../../service.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  @Output() collapsedChange = new EventEmitter<boolean>();
  isCollapsed: boolean = false;
  constructor(private router: Router, private authService: AuthServiceService, private apiService : ServiceService) { }
  name = localStorage.getItem('EmployeeName');
  ngOnInit(): void {
  }

  ToggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.collapsedChange.emit(this.isCollapsed);
  }
  log_out() {
    const body = {}
    this.apiService.Logout(body).subscribe({
      next : res => {
        if(res.success){
          this.apiService.showToast('success','Logout Successful')
          this.authService.logout();
        }else{
          this.apiService.showToast('error','Logout Unsuccessful')
        }
      },
      error : err => {        
        this.apiService.showToast('error','Logout Unsuccessful')
      }
    })

  }

  // @ViewChild('logoutLink') logoutLinkRef!: ElementRef;
  // shiftButton(event: MouseEvent) {
  //   const logoutLink = this.logoutLinkRef.nativeElement as HTMLAnchorElement;
  //   console.log(logoutLink,'yy');
  //   logoutLink.style.position = 'absolute'
  //   logoutLink.style.left = `${Math.ceil(Math.random() * 90)}%`;
  //   logoutLink.style.top = `${Math.ceil(Math.random() * 90)}%`;
  // }
}
